import HomePage from '../views/HomePage.vue'
import AllCategories from '../views/AllCategories.vue'
import CategoryPage from '../views/categories-pages/CategoryPage.vue'
import AllProducts from '../views/AllProducts.vue'
import ProductPage from '../views/products-pages/ProductPage.vue'
import AboutPage from '../views/AboutPage.vue'
import ContactUsPage from '../views/ContactUsPage.vue'

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomePage
	},
	{
		path: '/all-categories',
		name: 'all-categories',
		component: AllCategories
	},
	{
		path: '/category/:slug?',
		name: 'category',
		component: CategoryPage,
	},
	{
		path: '/all-products/:slug?',
		name: 'all-products',
		component: AllProducts,
	},
	{
		path: '/product/:slug?',
		name: 'product',
		component: ProductPage,
	},
	{
		path: '/about-us',
		name: 'about-us',
		component: AboutPage,
	},
	{
		path: '/contact-us',
		name: 'contact-us',
		component: ContactUsPage,
	}
]

export default routes;